<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods, exportMethods, erpFixMessages } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from "sweetalert2";
  import Multiselect from "vue-multiselect";
  import moment from 'moment-timezone';

  /**
   * E-Load Promo Schedule List component
   */
  export default {
    page: {
      title: "E-Load Promo Schedule"
    },
    components: {
      flatPickr,
      Multiselect
    },
    computed: {
      ...digitalLoadComputed,
      ...erpFixMessages,
      eloadPromosOptions: {
        get() {
          return this.loadPromoList.map((eload) => {
            return { text: eload.promoName, value: eload.promoId };
          });
        },
      },
      selectedPromos: {
        get() {
          var selected = [];

          console.log(this.formData.promoIds);

          this.eloadPromosOptions.forEach((eload) => {
            // console.log(eload.value);
            if (this.formData.promoIds.includes(eload.value)) {
              selected.push(eload);
            }
          });
          return selected.length > 0 ? selected : null;
        },
        set(promos) {
          var selected = [];
          promos.forEach((c) => {
            selected.push(c.value);
          });
          this.formData.promoIds = selected;
        },
      },
    },
    data() {
      return {
        ...digitalLoadMethods,
        rangeOptions: {
          enableTime: true,
          dateFormat: "Y-m-d H:i:00",
          altInput: true,
          altFormat: "m/d/Y - h:i K",
        },

        listPromos: [],
        scheduleId: 0,
        title: "E-Load Promo Schedule",

        formData: {
          scheduleId: 0,
          promoIds: [],
          command: null,
          timing: null,
          showWatermark: 0,
          remarks: {
            type: null,
            showUntil: null,
          },
        },
        searchValue: {
            page: 1,
            rows: 10,
            dateRange: null
        },
        logFields: [
          {key: "actor", label: "Modified By", sortable: false},
          {key: "created_At", label: "Modified Date & Time", sortable: false},
          {key: "remarks", label: "Changes", sortable: false}
        ],
        commandOptions: [
          { text: "Select Type of Command", value: null, disabled: true},
          { text: "Deactivate", value: "deactivate"},
          { text: "Activate", value: "activate"},
        ],
        remarksOption: [
          { text: "Select Remarks", value: null, disabled: true},
          { text: "Decommissioned", value: "decommissioned", disabled: true},
          { text: "New Offer", value: "newoffer", disabled: true},
        ],

        notesData: {
            "deactivate": {
                "0": {
                    watermarkTitle: `Show Watermark: `,
                    watermarkContent: `This will show the SKU in the app after its deactivation until the date selected. After which the SKU shall be removed.`
                },
                "1": {
                    watermarkTitle: `Show Watermark "Decommisioned" and SKU until this date: `,
                    watermarkContent: `This will show the SKU in the app after its deactivation until the date selected. After which the SKU shall be removed.`
                }
            },
            "activate": {
                "0": {
                    watermarkTitle: `Show Watermark: `,
                    watermarkContent: `This will add a "Newly added" tag on the newly created SKU until the end of the selected date`
                },
                "1": {
                    watermarkTitle: `Show Watermark as "Newly added" until this date: `,
                    watermarkContent: `This will add a "Newly added" tag on the newly created SKU until the end of the selected date`
                }
            }
        },
      };
    },
    methods: {
      ...exportMethods,
      ...layoutMethods,
      async submitForm(){
  
        // const params = {
        //   promoIds: this.formData.promoIds,
        //   timing: this.formData.timing,
        //   command: this.formData.command,
        //   remarks: this.formData.remarks
        // }
        const params = this.formData;
        
        console.log(JSON.stringify(params));

        if(this.scheduleId > 0) // Edit
        {
          const result = await this.actionEloadPromoSchedule({action: 'update', body: params});
          console.log("update result: ", result);

          if(result.status != 'err')
          {
            await Swal.fire({
                title: 'Update Successfull!',
                text: "E-Load Promo Schedule has been updated.",
                icon: 'success',
                // showCancelButton: true,
                // confirmButtonColor: '##804997',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                // cancelButtonText: 'No'
            }).then(async () => {
              // await this.getPromoScheduleDetails(this.scheduleId); 
              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "E-Load"
                }
              );
            })
          }
          else {
            await Swal.fire({
                title: 'Update failed!',
                text: result.message.description ?? result.message,
                icon: 'failed',
                // showCancelButton: true,
                // confirmButtonColor: '##804997',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                // cancelButtonText: 'No'
            });
          }
        }
        else { // Create

          const result = await this.actionEloadPromoSchedule({action: 'create', body: params});
          console.log("create result: ", result);

          if(result.status != 'err')
          {
            await Swal.fire({
                title: 'Update Successfull!',
                text: "E-Load Promo Schedule has been created.",
                icon: 'success',
                // showCancelButton: true,
                // confirmButtonColor: '##804997',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                // cancelButtonText: 'No'
            }).then(async () => {
              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "E-Load"
                }
              );
            })
          }
          else {
            await Swal.fire({
                title: 'Update failed!',
                text: result.message.description ?? result.message,
                icon: 'failed',
                // showCancelButton: true,
                // confirmButtonColor: '##804997',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                // cancelButtonText: 'No'
            });
          }

          
        }
      },
      promoName() {
        const promo = this.selectedPromos.find(val => val.value == this.formData.promoIds[0]);
        return promo ? promo.text : "Default Text"; // Return the text if promo is found, otherwise return a default text
      },
      returnNotes() {        
        return {title: this.notesData[this.formData.command ?? "deactivate"][this.formData.showWatermark.toString()].watermarkTitle ,
                content: this.notesData[this.formData.command ?? "deactivate"][this.formData.showWatermark.toString()].watermarkContent};
      },
      async logsSearch(status) {
        if(status == "reset"){
          this.searchValue.page = 1;//{}}
        }
        const result = await this.actionEloadPromoSchedule({action: 'logs', body: {...this.searchValue, module: 'ELOAD_PROMO_SCHEDULER', orderDesc: true, sort: "id", promoId: this.formData.promoIds[0]}});
        console.log("logs res", result);
        // await this.auditCancellationRequestLogs({...this.searchValue, "cancellationId":this.cancellationId})
        // .then(()=>{
        // });
      },
      remarksOptionChanged() {
        this.formData.remarks.type = null
        this.remarksOption[1].disabled = true;
        this.remarksOption[2].disabled = true;
        if(this.formData.command == "deactivate") this.remarksOption[1].disabled = false; 
        if(this.formData.command == "activate") this.remarksOption[2].disabled = false; 
      },
      async onExport() {
        const headers = {
            'Modified By':'actor',
            'Modified Date & Time':'created_at',
            'Changes': 'remarks'
        }

        // reformatting the data from promologs
        let logLists = this.schedulePromoLogsList.map(object => {
            const newObj = {};
            // eslint-disable-next-line no-unused-vars
            for (const [headerKey, dataKey] of Object.entries(headers)) {
                newObj[dataKey] = dataKey === 'created_at'
                    ? moment(object[dataKey]).tz('Asia/Manila').format("LLL")
                    : object[dataKey];
            }
            return newObj;
        }).reverse();
        console.log("logLists: ", logLists);

        const promoName = this.promoName();

        const sheets = [
            {
                title: `Eload Promo Scheduling Logs ${promoName}`,
                headers: Object.keys(headers).map(h => Object.assign({"text": h})),
                rows: logLists
            }
        ]
    
        let params = {
          email: JSON.parse(localStorage.getItem('userData')).email,
          filename: `eload_promo_scheduling`,
          sheets: sheets,
          subject: `${promoName} - Eload Promo Scheduling Logs`,
          reportName: `Eload Promo Scheduling Logs for ${promoName}`
        }; 

        this.exportReportXLSL(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      async getPromoList() {

        try {

          if(this.scheduleId > 0)
          {
            await this.getLoadPromoList({
              carrier: "globe",
              body: {
                page: 1,
                rows: 99999,
              }
            });
          }
          else {
            const result = await this.actionEloadPromoSchedule({action: 'promos', body: null});
            console.log("promos result: ", result);
            const {status} = result;
            if(status == 'ok')
            {
              this.listPromos = this.loadPromoList;
            }
          }
        }
        catch(e)
        {
          console.log("Error on getPromoList: ", e);''
        }
        
      },
      async getPromoScheduleDetails(id) {
        const result = await this.actionEloadPromoSchedule({action: 'details', body: {id: id}});
        console.log("details result: ", result);

        const {status, message} = result;
        if(status == 'err')
        {
          Swal.fire({
              title: 'Error',
              text: `Promo Schedule does not exists!`,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: 'red',
              // cancelButtonColor: '#7F4697',
              confirmButtonText: 'Ok',
              // cancelButtonText: 'No'
          }).then(() => {
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "E-Load"
              }
            );
          })
          return;
        }

          this.formData = {
            scheduleId: message.rows.id,
            promoIds: [message.rows.eload_promo_id],
            command: message.rows.schedule_status,
            
            timing: moment(message.rows.schedule_datetime).tz('Asia/Manila').format("YYYY-MM-DD HH:mm:ss"),
            showWatermark: message.rows.show_watermark,
            remarks: {
              type: message.rows.remarks,
              showUntil: moment(message.rows.watermark_sched).tz('Asia/Manila').format("YYYY-MM-DD HH:mm:ss"),
            }
          }

          const logsRes = await this.actionEloadPromoSchedule({action: 'logs', body: {module: 'ELOAD_PROMO_SCHEDULER', promoId: message.rows.eload_promo_id, orderDesc: true, sort: "id"}});
          console.log("logs result: ", logsRes);


          // await this.$refs.observer.validate();
          // this.$ref.observer.validate();

          console.log("this.formData: ", this.formData);
        
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      
      goBack(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load"
          }
        );
      },
      openModal(){
        this.logsSearch('reset');
        this.$bvModal.show(`bv-modal-view-logs`);
      },
      closeModal(){
        this.$bvModal.hide(`bv-modal-view-logs`);
      },
      
      
      leaveform(next){
          if(JSON.stringify(this.cancellationRequestForm) == JSON.stringify(this.formExitChecker)){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{  
                  return;
              }
          })
      },
    },
    async mounted(){
      this.scheduleId = this.$route.params.id ?? 0;
      console.log("this.scheduleId ", this.scheduleId); 
      this.changeTitle({title: 'E-Load Promo Schedule'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'E-Load Promo', to: { name: 'E-Load'} },
          { text: 'E-Load Promo Scheduler', to: { name: 'E-Load Scheduler'}},
        ]
      });

      await this.getPromoList();

      if(this.scheduleId > 0)
      {
        await this.getPromoScheduleDetails(this.scheduleId); 
      }
      
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.cancellationRequestForm) != JSON.stringify(this.formExitChecker)){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-md-6 col-12">
            <div class="card">
                <div class="card-body">
                      <ValidationObserver v-slot="{ handleSubmit, reset }" ref="observer">
                        <b-form
                          @submit.prevent="handleSubmit(submitForm)"
                          @reset.prevent="reset"
                        >
                          <b-form-group class="mb-3">
                            <label>Select Promo <span style="color: red">*</span></label>
                              <validation-provider
                                  name="select promo"
                                  rules="required"
                                  v-slot="validationContext"
                                >
                                <multiselect
                                    :multiple="true"
                                    v-model="selectedPromos"
                                    :options="eloadPromosOptions"
                                    track-by="value"
                                    label="text"
                                    name="selectPromo"
                                    select-label="Click to select"
                                    deselect-label="Click to remove"
                                    placeholder="Select Promo"
                                    :allow-empty="true"
                                    :preselect-first="false"
                                    :hide-selected="true"
                                    :close-on-select="false"
                                    :class="{
                                      invalid: getValidationState(validationContext) === false,
                                      'is-valid': getValidationState(validationContext) === true,
                                    }"
                                    :disabled="(scheduleId > 0)"
                                  ></multiselect>
                                  <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                  </b-form-invalid-feedback>
                                </validation-provider>
                          </b-form-group>

                          <b-form-group class="mb-3">
                            <label>Type of Command <span style="color: red">*</span></label>
                            <validation-provider
                              name="Type Command"
                              rules="required"
                              v-slot="validationContext"
                            >
                               <b-form-select
                                v-model="formData.command"
                                :options="commandOptions"
                                class="form-select text-gray-500"
                                :state="getValidationState(validationContext)"
                                @change="remarksOptionChanged">
                              </b-form-select>
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </validation-provider>
                          </b-form-group>

                          <b-form-group  class="mb-3">
                            <label>Timing <span style="color: red">*</span></label>
                            <validation-provider
                              name="date range"
                              rules="required"
                              v-slot="validationContext"
                            >
                              <div class="input-group timing">
                                <span class="input-group-text bg-transparent border-end-0 icon-datetime">
                                  <i class="bx bx-calendar" :style="{ fontSize: '1.2rem' }"></i>
                                </span>
                                <flat-pickr
                                  ref="flatpickrInput"
                                  v-model="formData.timing"
                                  :config="rangeOptions"
                                  placeholder="Date & Time"
                                  class="form-control border-start-0 timing"
                                  :class="{
                                    'is-invalid': (getValidationState(validationContext) == false),
                                    'is-valid': (getValidationState(validationContext) == true),
                                  }"
                                ></flat-pickr>
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </div>
                              
                              
                            </validation-provider>
                          </b-form-group>

                          <b-form-group  class="mb-3">
                            <div class="d-flex align-items-center">
                              <span class="flex-grow-1" style="font-weight: 600;">{{ returnNotes().title }} <span v-if="formData.showWatermark" style="color: red">*</span></span> 
                              <div 
                                class="form-check form-switch form-switch-md" 
                                dir="ltr">
                                <input
                                    v-model="formData.showWatermark"
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="'customSwitchsizem'"
                                    value="1"
                                    :true-value="1"
                                    :false-value="0"
                                    checked
                                  />
                                  <span style="font-size: 12px">{{!formData.showWatermark ? "Disable" : "Enable"}}</span>
                              </div>
                            </div>
                            <b-form-group  class="mb-3" v-if="formData.showWatermark == 1">
                              <validation-provider
                                name="show until"
                                rules="required"
                                v-slot="validationContext"
                              > 
                                <div class="input-group schedule">
                                  <span class="input-group-text bg-transparent border-end-0 icon-datetime">
                                    <i class="bx bx-calendar" :style="{ fontSize: '1.2rem' }"></i>
                                  </span>
                                  <flat-pickr
                                    ref="flatpickrInput"
                                    v-model="formData.remarks.showUntil"
                                    :config="rangeOptions"
                                    placeholder="Schedule Date & Time"
                                    class="form-control border-start-0 schedule"
                                    :class="{
                                    'is-invalid': (getValidationState(validationContext) == false),
                                    'is-valid': (getValidationState(validationContext) == true),
                                  }"
                                  ></flat-pickr>
                                  <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                                </div>
                              </validation-provider>
                            </b-form-group>
                            <p class="mt-2" style="font-size: 13px;"><span style="font-weight: 600;">Note:</span> {{ returnNotes().content }}</p>
                          </b-form-group>
                          <b-form-group>
                            <label>Remarks <span style="color: red">*</span></label>
                            <validation-provider
                              name="Select Remarks"
                              rules="required"
                              v-slot="validationContext"
                            >
                             
                               <b-form-select
                                :options="remarksOption"
                                v-model="formData.remarks.type"
                                class="form-select shadow-none"
                                :state="getValidationState(validationContext)"
                                >
                              </b-form-select>
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </validation-provider>
                          </b-form-group>

                          <div class="mt-2 d-flex align-items-center">
                            <span v-if="(scheduleId > 0)" class="flex-grow-1">
                              <b class="me-2">Change Log:</b>
                              <b-link @click="openModal('bv-modal-view-logs')">View</b-link>
                            </span>
                            <router-link :to="{ name: 'E-Load'}" class="text-capitalize">
                              <b-button variant="light" class="float-end me-2 px-5" type="button" >Cancel</b-button>
                            </router-link>

                            <b-button
                              class="float-end me-3 px-5"
                              type="submit"
                              variant="primary"
                            >
                              Save
                            </b-button>
                          </div>
                        </b-form>
                      </ValidationObserver>
                    
                  
                  <b-modal id="bv-modal-view-logs" title="View Logs" size="lg" hide-header hide-title hide-footer hide-header-close>
                    <h5>Cancellation Log</h5>
                    <div class="d-flex flex-row col-12 my-4">
                      <div class="me-3">
                        <b-form-group>
                          <template v-slot:description><div class="d-flex justify-content-end">Filter by Date</div></template>
                          <flat-pickr
                            v-model="searchValue.dateRange"
                            :config="{mode: 'range'}"
                            placeholder="Select a date range"
                            class="form-control"
                            style="width: fit-content"
                          ></flat-pickr>
                        </b-form-group>
                      </div>
                      <div class="me-3">
                        <b-form-group label="">
                          <b-button variant="primary" type="button" class="px-2 me-3" @click="logsSearch('reset')">
                            <i class='bx bx-search bx-fw'></i>
                            Search
                          </b-button>
                          <b-button variant="primary" type="button" class="px-2" @click="onExport">
                            <i class="uil uil-export me-1"></i>
                            Export
                          </b-button>
                        </b-form-group>
                      </div>
                    </div>
                    <div>
                      <div class="table-responsive">
                        <div class="table align-middle table-nowrap">
                          <b-table
                            :items="schedulePromoLogsList"
                            :fields="logFields"
                            responsive="md"
                            class="table-check"
                          >
                            <template #cell(actor)="data">
                              {{ data.item.actor}}
                            </template>
                            <template #cell(created_at)="data">
                              {{ data.item.created_at | customFormatDate }}
                            </template>
                            <template #cell(remarks)="data">
                              {{ data.item.remarks}}
                            </template>
                          </b-table>
                        </div>
                      </div>
                      <div class="row g-0 text-center" v-if="schedulePromoLogsTotal == 0">
                        <span>No data to display.</span>
                      </div>
                      <div class="row" v-if="schedulePromoLogsTotal != 0 && schedulePromoLogsTotal > searchValue.rows">
                        <div class="col">
                          <div
                            class="
                              dataTables_paginate
                              paging_simple_numbers
                              float-end
                            "
                          >
                            
                            <b-pagination
                              class="pagination-rounded"
                              v-model="searchValue.page"
                              :total-rows="schedulePromoLogsTotal"
                              @input="logsSearch()"
                              :per-page="searchValue.rows"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-end">
                      <b-button type="button" variant="light" @click="closeModal()">
                        close
                      </b-button>
                    </div>
                  </b-modal>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>
<style>


.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e !important;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(2.575em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.multiselect.is-valid .multiselect__tags {
  border-color: #51d28c !important;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2351d28c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(2.575em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}


.input-group.timing:has(.is-invalid) > .form-control.border-start-0.timing.input { 
  border-color: #f34e4e !important;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.input-group.timing:has(.is-valid) > .form-control.border-start-0.timing.input { 
  border-color: #51d28c !important;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2351d28c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.input-group.timing:has(.is-valid) > .input-group-text.icon-datetime {
  border-color: #51d28c !important;
}

.input-group.timing:has(.is-invalid) > .input-group-text.icon-datetime {
  border-color: #f34e4e !important;
}




.input-group.schedule:has(.is-invalid) > .form-control.border-start-0.schedule.input { 
  border-color: #f34e4e !important;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.input-group.schedule:has(.is-valid) > .form-control.border-start-0.schedule.input { 
  border-color: #51d28c !important;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2351d28c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.input-group.schedule:has(.is-valid) > .input-group-text.icon-datetime {
  border-color: #51d28c !important;
}

.input-group.schedule:has(.is-invalid) > .input-group-text.icon-datetime {
  border-color: #f34e4e !important;
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #e73092;
  color: #ffffff;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #ffffff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}
</style>